import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useBackoffice } from '../backoffice/useBackoffice';

export const useInitiateTransferWithdrawalStage = () => {
  const { developerId } = useBackoffice();
  const { getAccessTokenSilently } = useAuth0();
  const mutation = useMutation({
    mutationKey: ['initiate-transfer-withdrawal-stage'],
    mutationFn: async (payload: {
      transfer_id: string;
      transfer_type: string;
      offramp?: {
        withdrawal_transaction_source_network?: string;
      };
    }) => {
      const token = await getAccessTokenSilently();
      await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/customers/transfers/withdrawal`, payload, {
        params: {
          consumerId: developerId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
  });

  return {
    initiateTransferWithdrawalStage: mutation.mutateAsync,
    isInitiatingTransferWithdrawalStage: mutation.isPending,
  };
};
